import VSystemBar from './VSystemBar'

VSystemBar.install = function install (Vue) {
  Vue.component(VSystemBar.name, VSystemBar)
}

export default VSystemBar



// WEBPACK FOOTER //
// ./src/components/VSystemBar/index.js